import { INIT_SEARCH_FILTER, INIT_OPT_SD, INIT_PERIMETER_TYPE } from '../../../settings/scoringProfilesSettings'

const SET_PERIMETER_TYPE = (ctx, payload) => {
  if (!payload) {
    payload = ['0']
  }

  ctx.ptType = payload
  if (payload[0] === '1') {
    ctx.currentFilters.perSD = INIT_OPT_SD()
  } else {
    ctx.currentFilters.perSD = null
  }
}

export default {
  namespaced: true,

  state: {
    currentFilters: INIT_SEARCH_FILTER(),
    defaultFilters: INIT_SEARCH_FILTER(),
    ptType: INIT_PERIMETER_TYPE(),
  },

  mutations: {
    setCurrentFilters(state, payload) {
      state.currentFilters = payload
    },

    setDefaultFilters(state, payload) {
      state.defaultFilters = payload
    },

    setPerimeterType(state, payload) {
      SET_PERIMETER_TYPE(state, payload)
    },
  },

  actions: {
    setCurrentFilters({ commit }, filters) {
      commit('setCurrentFilters', filters)
    },

    setDefaultFilters({ commit }, filters) {
      commit('setDefaultFilters', filters)
    },

    setPerimeterType({ commit }, payload) {
      commit('setPerimeterType', payload)
    },
  },

  getters: {
    getCurrentFilters: (state) => {
      return state.currentFilters
    },
  },
}
